import * as Yup from "yup"

export const SchemaValidation = (t) => Yup.object().shape({
  name: Yup.string().required(t('required')),
  phone: Yup.string().required(t('required')),
  email: Yup.string().required(t('required')),
  password: Yup.string().required(t('required')),
  role: Yup.string().required(t('required')),
  company: Yup.string().required(t('required')),
  branch_offices: Yup.array().of(Yup.string()).required(t('required')).min(1, "Debes seleccionar al menos una opción").typeError("Debes seleccionar al menos una opción"),
  active: Yup.boolean().required(t('required'))
})

export const SchemaValidationUpdate = (t) => Yup.object().shape({
  name: Yup.string().required(t('required')),
  phone: Yup.string().required(t('required')),
  email: Yup.string().required(t('required')),
  password: Yup.string().nullable(),
  role: Yup.string().required(t('required')),
  company: Yup.string().required(t('required')),
  branch_offices: Yup.array().of(Yup.string()).required(t('required')).min(1, "Debes seleccionar al menos una opción").typeError("Debes seleccionar al menos una opción"),
  active: Yup.boolean().required(t('required'))
})